export default __webpack_public_path__ + "static/media/profile.82212672.png";